import React from 'react';
import { ModalTheme } from '../../../../../../components/modal';
import { useForm } from 'react-hook-form';
import { TextLarge, TextSmall } from '../../../../../../components/text';
import { ContainerButton } from '../../../../../../styles/global-style';
import { ButtonTheme } from '../../../../../../components/buttons';
import { useConfirmDateBooking } from '../hooks/useConfirmDateBooking';

export const ComfirmDateBooking = ({ open, onToggle, item }) => {
  const { handleSubmit } = useForm();
  const { claimId, claimCode } = item;
  const { mutate: confirmDateBooking } = useConfirmDateBooking();

  const onSubmit = () => {
    const payload = {
      claimId: claimId,
      claimCode: claimCode,
    };
    confirmDateBooking(payload);
    onToggle({ defaultValue: '' });
  };

  return (
    <ModalTheme title=" " open={open} onToggle={onToggle}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <TextLarge text={'ยืนยันการอนุมัติให้เคลมสินค้า'} bold />
      </div>
      <div
        style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', color: '#656565' }}
      >
        <TextSmall text={'วันที่ ' + item?.bookingDate} bold />
      </div>
      <div
        style={{
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'center',
          color: '#656565',
        }}
      >
        <TextSmall text={'สาขา ' + item?.storeName} bold />
      </div>
      <ContainerButton right>
        <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};
